// Copyright (c) 2019 Deere & Company

import './info-alert-bar.scss';
import { AlertBarBase } from './alert-bar-base';
import PropTypes from 'prop-types';
import React from 'react';

export const InfoAlertBar = props => (
    <div className="info-alert-bar">
        <AlertBarBase
            alertTitle={props.alertTitle}
            canDismiss={props.canDismiss}
            dismissHandler={props.dismissHandler}
            iconClass="icon-info-white"
            timeoutLength={props.timeoutLength}
            willAutoDismiss={props.willAutoDismiss}
        >
            {props.children}
        </AlertBarBase>
    </div>
);

InfoAlertBar.propTypes = {
    alertTitle: PropTypes.any.isRequired,
    canDismiss: PropTypes.bool,
    children: PropTypes.any.isRequired,
    dismissHandler: PropTypes.func.isRequired,
    timeoutLength: PropTypes.number,
    willAutoDismiss: PropTypes.bool,
};

InfoAlertBar.defaultProps = {
    canDismiss: true,
    willAutoDismiss: false,
};
